import { Page } from "./Page";
import { OnlineStorage } from "@tblabs/storage";
import { UserProvider } from "../Services/UserProvider";
import { ChatViewer } from "../Components/ChatViewer";
import { Chat } from "../Services/Chat";


export class ChatPage extends Page
{
    constructor(_storage: OnlineStorage, _user: UserProvider, chatId: string)
    {
        super("Czat #" + chatId);

        if (!chatId)
        {
            window.location.hash = "chat/new";
        }

        this.Content(async (body) =>
        {
            const chat = new Chat(_storage, _user, chatId);

            await chat.Load();

            body.Append(
                new ChatViewer(chat),
            );
        });
    }
}
